// import Cart from '@/models/Cart';
import { postRequest, getRequest } from '@/api';
import {
  SAFETY_NUMBER_GET_MUTATIONS,
  SAFETY_NUMBER_SET_MUTATIONS,
} from '@/store/mutation-types';
import SafetyNumber from '@/models/SafetyNumber';

export const state = () => {
  return {
    safetyNumbers: [],
    initPending: null,
    pending: null,
    error: null,
    activeSlide: 0,
  };
};

export const actions = {
  async fetch({ commit }) {
    const success = await getRequest(
      '/faf',
      SAFETY_NUMBER_GET_MUTATIONS,
      commit
    );

    return success;
  },
  async removeNumber({ commit, state }, payload) {
    const initialSafetyNumbers = Object.assign([], state.safetyNumbers);
    commit(
      'SAFETY_NUMBER_SET_NUMBERS',
      state.safetyNumbers.filter(
        number => number.fafNumber !== payload.fafNumber
      )
    );
    const success = await postRequest(
      '/faf/remove',
      payload,
      SAFETY_NUMBER_SET_MUTATIONS,
      commit
    );
    if (!success) {
      commit('SAFETY_NUMBER_SET_NUMBERS', initialSafetyNumbers);
    }
    return success;
  },
  async addNumber({ commit, state }, payload) {
    const initialSafetyNumbers = Object.assign([], state.safetyNumbers);
    commit('SAFETY_NUMBER_SET_NUMBERS', [
      ...state.safetyNumbers,
      new SafetyNumber(payload),
    ]);
    const success = await postRequest(
      '/faf/add',
      payload,
      SAFETY_NUMBER_SET_MUTATIONS,
      commit
    );
    if (!success) {
      commit('SAFETY_NUMBER_SET_NUMBERS', initialSafetyNumbers);
    }
    return success;
  },
};

export const mutations = {
  [SAFETY_NUMBER_GET_MUTATIONS.SUCCESS]: (state, data) => {
    state.safetyNumbers = data.map(
      safetyNumber => new SafetyNumber(safetyNumber)
    );
  },
  [SAFETY_NUMBER_GET_MUTATIONS.PENDING]: (state, pending) =>
    (state.initPending = pending),
  [SAFETY_NUMBER_GET_MUTATIONS.FAILURE]: (state, error) =>
    (state.error = error),
  [SAFETY_NUMBER_SET_MUTATIONS.SUCCESS]: (state, data) => {
    state.safetyNumbers = data.map(
      safetyNumber => new SafetyNumber(safetyNumber)
    );
  },
  [SAFETY_NUMBER_SET_MUTATIONS.PENDING]: (state, pending) =>
    (state.pending = pending),
  [SAFETY_NUMBER_SET_MUTATIONS.FAILURE]: (state, error) =>
    (state.error = error),
  SAFETY_NUMBER_SET_NUMBERS: (state, payload) => {
    state.safetyNumbers = payload;
  },
};

export const getters = {
  safetyNumbers: state => state.safetyNumbers,
  pending: state => state.pending,
  initPending: state => state.initPending,
  getFafInd: state => msisdn => {
    const numbers = state.safetyNumbers.filter(
      number => number.fafNumber === msisdn
    );
    if (numbers.length > 0) {
      return numbers[0].fafIndicator;
    }
    return null;
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
